import localStorageService from 'services/localStorage';
import history from 'shared/services/history';
import { OTP } from 'routes/paths';
import { getRouteWithToken } from 'utilities';

class SessionService {
  tempState = {};

  saveSession = (token, sessionId) => {
    const key = `${token}_session`;
    localStorageService.setItem(key, sessionId);
    this.tempState[key] = sessionId;
  };

  getSession = token => {
    const key = `${token}_session`;
    return localStorageService.getItem(key) || this.tempState[key];
  };

  clearSession = token => {
    const key = `${token}_session`;
    localStorageService.removeItem(key);
    delete this.tempState[key];
  };

  handleUnauthorizedError = (error, token) => {
    const { error_code: errorCode } = error?.response?.data?.status || {};
    const isUnauthorizedError = errorCode === 'UNAUTHORIZED_API_CALL';

    if (isUnauthorizedError) {
      this.clearSession(token);
      const otpRoute = getRouteWithToken(OTP, token);
      history.push(otpRoute);
    }

    return isUnauthorizedError;
  };
}

export default new SessionService();
